import { getElements, ifSelectorExist } from "./utils-child";

export const counterAnimation = () => {
  const counters = getElements(".findlay-counter__items__title");
  const animationDuration = 1000;

  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const startAnimation = (counter) => {
    const targetValue = parseFloat(counter.getAttribute("num").replace(/,/g, ""));
    const startValue = parseFloat(counter.innerText.replace(/,/g, "")) || 0;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      if (elapsedTime < animationDuration) {
        const progress = elapsedTime / animationDuration;
        const currentValue = startValue + (targetValue - startValue) * progress;
        counter.innerText = formatNumber(Math.ceil(currentValue));
        requestAnimationFrame(animate);
      } else {
        counter.innerText = formatNumber(targetValue);
      }
    };

    requestAnimationFrame(animate);
  };

  if (ifSelectorExist(counters)) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const counter = entry.target;
          observer.unobserve(counter);
          counter.innerHTML = 0;
          startAnimation(counter);
        }
      });
    });

    counters.forEach((counter) => {
      observer.observe(counter);
    });
  }
};